import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'app-menu-style2',
  templateUrl: './menu-style2.component.html',
  styleUrls: ['./menu-style2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuStyle2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/mega-menu/menu-style2/menu-style2.component.ts